import styled, { css } from "styled-components";

export default function BrandCard(props) {
    const { id, name, ...restProps } = props;
    return (
        <Styled
            as={ props.onClick ? "button" : "div" }
            { ...restProps }
        >
            <span className="name">{ name }</span>
        </Styled>
    );
}

const Styled = styled.button`
    align-items: flex-start;
    background: transparent;
    color: #000;
    border: 1px solid transparent;
    border-radius: 2px;
    cursor: default;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 8px 24px 8px 16px;
    transition: 200ms;

    .name {
        font-size: 3.2em;
        letter-spacing: -.04em;
    }

    ${ ({ onClick }) => onClick && CSSClickable }
`;

const CSSClickable = css`
    cursor: pointer;

    &:hover {
        .name {
            text-decoration: underline;
        }
    }
`;
